export default "__VITE_ASSET__Bu0PYS4r__"